import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { publish } from '../utils/socket';
import Loader from '../components/Loader';
// import Actions from '../business/Actions';
// import Message from '../components/Message';

//subscribe page
const Subscribe = ()=>{

    const {ref} = useParams();
    const [loading,setLoading] = React.useState(false);
    const {userInfo}           = useSelector(state=>state.userLogin);
    const {tickets}             = useSelector(state=>state.ticket);
    

    React.useEffect(()=>{

        try {
            
            setLoading(true);

            const openID = ref.split('::')[0] ? ref.split('::')[0] : userInfo?.open_id;

            const ticketID = ref.split('::')[1] ? ref.split('::')[1] :'';
            
            console.log('the openID',openID);

            if(openID && openID === userInfo?.open_id) return;
            
            publish({
                type   :'TICKET_LOGIN',
                openID,
                ticketID
            });
    
            setTimeout(()=>{
                setLoading(false);
            },3000);
    

        } catch (error){}
  
    },[ref,userInfo]);

    return ( 
         <>{
            loading  
            ?  (
                  <Loader />
               )
            :
                (
                    <>
                     
                        <div> 
                        {
                            tickets?.filter(x=>!['C','D'].includes(x.status))?.length > 0 ? (
                                <div>
                                tickets 
                                </div>
                            ) : (
                                <div>dashboard</div>
                            )
                        }
                        </div>
                    </>
                )
            }
            
     
        </>);
}

export default Subscribe;
